module.exports = __webpack_public_path__ + "img/gallery-close.8cf075dd.svg";